import { render, staticRenderFns } from "./LeftDevice.vue?vue&type=template&id=5621da47"
import script from "./LeftDevice.vue?vue&type=script&lang=js"
export * from "./LeftDevice.vue?vue&type=script&lang=js"
import style0 from "./LeftDevice.vue?vue&type=style&index=0&id=5621da47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports